<template>
  <span>
    <span class="label label-success" v-show="value" @click="$emit('hide')">Visible</span>
    <span class="label label-default label-flat text-grey-300" v-show="!value" @click="$emit('show')">Masqué</span>
  </span>
</template>

<script>
  export default {
    props: {
      value: Boolean,
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/PublishingStatus.vue